import {marked} from "marked";
import {LegalPage} from "~/components/legalPage";
import source from "~/content/legal/cookies-policy.md?raw";

const html = marked.parse(source, {async: false});

export function meta() {
    return [{title: "Cookie Policy, Intellsys OS"}];
}

export default function RouteComponent() {
    return (
        <LegalPage
            title="Cookie Policy"
            html={html}
            updatedOn="2026-06-05"
        />
    );
}
